// src/components/LanguageSelector.jsx
import React, { useContext } from "react";
import { LanguageContext } from "../contexts/LanguageContext";
import Select from "react-select";

const LanguageSelector = ({ isMobile = false }) => {
  const { language, changeLanguage } = useContext(LanguageContext);

  const languages = [
    { value: "en", label: "English", flag: "🇬🇧" },
    { value: "am", label: "አማርኛ", flag: "🇪🇹" },
    { value: "or", label: "Afaan Oromoo", flag: "/flags/oromia.png" },
    { value: "ti", label: "ትግርኛ", flag: "/flags/tigray.png" },
    { value: "wo", label: "Wolayttatstsuwa", flag: "/flags/wolayta.png" },
];

  const selectedOption =
    languages.find((lang) => lang.value === language) || languages[0];

  const customStyles = {
    container: (provided) => ({
      ...provided,
      width: isMobile ? "160px" : "180px",
      marginLeft: isMobile ? "auto" : "0.5rem",
      marginRight: isMobile ? "0.5rem" : "0",
      zIndex: 1000,
      position: "relative",
    }),
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "transparent",
      border: "none",
      minHeight: "36px",
      cursor: "pointer",
      boxShadow: "none",
      width: "100%",
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.05)",
      },
      borderRadius: "6px",
      borderColor: state.isFocused ? "rgba(66, 153, 225, 0.5)" : "transparent",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#ffffff",
      fontSize: isMobile ? "14px" : "15px",
      display: "flex",
      alignItems: "center",
      margin: 0,
      padding: 0,
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#2a2a2a",
      zIndex: 9999,
      width: isMobile ? "180px" : "160px",
      right: isMobile ? "0" : "auto",
      left: isMobile ? "auto" : "0",
      marginTop: "8px",
      borderRadius: "6px",
      border: "1px solid rgba(255, 255, 255, 0.1)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
      overflow: "hidden",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#2b6cb0"
        : state.isFocused
        ? "#4299e1"
        : "transparent",
      color: "#ffffff",
      cursor: "pointer",
      fontSize: "14px",
      padding: "10px 12px",
      ":active": {
        backgroundColor: "#2b6cb0",
      },
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#a0aec0",
      padding: isMobile ? "6px" : "8px",
      ":hover": {
        color: "#ffffff",
      },
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: isMobile ? "0 6px" : "2px 8px",
      overflow: "visible",
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
  };

  const formatOptionLabel = ({ label, flag }) => (
  <div className="flex items-center space-x-2">
    {flag.startsWith('/') ? (
      <img src={flag} alt={label} className="w-5 h-3 rounded-sm object-cover" />
    ) : (
      <span className="text-base">{flag}</span>
    )}
    <span className="truncate">{label}</span>
  </div>
);

  return (
    <div
      className={`relative ${isMobile ? "ml-auto px-1" : ""}`}
      style={{ minWidth: isMobile ? "100px" : "135px" }}
    >
      <Select
        className="language-select"
        classNamePrefix="select"
        value={selectedOption}
        onChange={(selected) => changeLanguage(selected.value)}
        options={languages}
        isSearchable={false}
        styles={customStyles}
        formatOptionLabel={formatOptionLabel}
        menuPlacement={isMobile ? "bottom" : "auto"}
        menuPortalTarget={isMobile ? document.body : undefined}
        menuShouldScrollIntoView={false}
        aria-label="Select language"
        components={{
          IndicatorSeparator: null,
        }}
      />
    </div>
  );
};

export default LanguageSelector;
